import { createSlice } from "@reduxjs/toolkit";
import { getReactivatedCustomers } from "./reactivatedCustomersAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  customers: [],
  latestRequestId: null,
};

const reactivatedCustomersSlice = createSlice({
  name: "reactivatedCustomers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReactivatedCustomers.pending, (state, action) => {
        state.loading = true;
        state.customers = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getReactivatedCustomers.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.customers = action.payload;
        state.error = null;
      })
      .addCase(getReactivatedCustomers.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default reactivatedCustomersSlice.reducer;
